import React from 'react';

export default function SectionDivider({ tone = 'light' }) {
  const ruleColor = tone === 'dark' ? 'bg-white/20' : 'bg-clay/25';
  const beanFilter =
    tone === 'dark'
      ? 'brightness(0) saturate(100%) invert(68%) sepia(54%) saturate(478%) hue-rotate(358deg) brightness(98%) contrast(92%)'
      : 'brightness(0) saturate(100%) invert(33%) sepia(18%) saturate(1247%) hue-rotate(340deg) brightness(93%) contrast(88%)';

  return (
    <div
      role="presentation"
      className={`flex items-center justify-center gap-6 py-10 ${tone === 'dark' ? 'bg-gray-900' : ''}`}
    >
      <span className={`h-px w-16 sm:w-24 ${ruleColor}`} aria-hidden="true" />
      <img
        src="/flow-assets/logos/coffee-bean.svg"
        alt=""
        aria-hidden="true"
        className="w-5 h-5 opacity-80"
        style={{ filter: beanFilter }}
      />
      <span className={`h-px w-16 sm:w-24 ${ruleColor}`} aria-hidden="true" />
    </div>
  );
}
